import { IconUser, IconCreditCard, IconCircleCheck, IconWorld, IconWallet } from '@tabler/icons-react';

import RouteHelper from "./RouteHelper";

import { PaymentType } from '../Enums/PaymentTypeEnum';
import { ActiveStatusEnum } from '../Enums/StatusEnums';
import { AdminModules } from '../Enums/AdminModulesEnum';
import { CurrencyEnum } from '../Enums/CurrencyEnums';
import { RouteEnum } from '../Enums/RouteEnums';
import { ValidityTypeEnum, ValidityType } from '../Enums/ValidityTypeEnums';
import { RoleTypeEnum } from '../Enums/RolesEnums';
import { RegistrationType, RegistrationTypeName, AccountType, AccountTypeName } from '../Enums/RegistrationEnum';

const queryStr = {
    pageSize: 2000,
    pageNumber: 1,
    searchString: '',
};

const DropdownOptionLists: any = {
	RespondTypeList: async function () {
		return [
			{
				id: 1,
				name: 'Target',
			},
			{
				id: 2,
				name: 'Review',
			},
		];
	},
	CountryList: async function () {
        return [
			{
				id: '1',
				name: "Malaysia",
				country: "Malaysia",
				currencyCode: 'MYR',
				code: "+60"
			},
			{
				id: '2',
				name: "Singapore",
				country: "Singapore",
				currencyCode: 'SGD',
				code: "+65"
			},
			{
				id: '3',
				name: "Indonesia",
				country: "Indonesia",
				currencyCode: 'IDR',
				code: "+62"
			},
			{
				id: '4',
				name: "Brunei",
				country: "Brunei",
				currencyCode: 'BND',
				code: "+673"
			},
			{
				id: '5',
				name: "Philippines",
				country: "Philippines",
				currencyCode: 'PHP',
				code: "+63"
			},
			{
				id: '6',
				name: "Thailand",
				country: "Thailand",
				currencyCode: 'THB',
				code: "+66"
			},
        ];
    },
    LicenseTypeList: async function () {
        return [
			{
				id: 1,
				name: "License Key",
			},
        ];
    },
    LicensePackageTypeList: async function () {
        return [
			{
				id: 1,
				name: "Starter Pack",
				description: "For Startup",
				annualPrice: 15000,
				isPopular: true,
				inclusions: [
					'Up to 50+ Users',
					'Up to 250 GB Storage',
					'Workforce',
					'Leave + e-Leave',
					'Attendance + e-Attendance',
					'Payroll + e-Payslip',
				],
			},
			{
				id: 2,
				name: "SMB100+ Pack",
				description: "Enterprise Businesses",
				annualPrice: 30000,
				isPopular: false,
				inclusions: [
					'Up to 100+ Users',
					'Up to 500 GB Storage',
					'Workforce',
					'Leave + e-Leave',
					'Attendance + e-Attendance',
					'Claim + e-Claim',
					'Payroll + e-Payslip',
				],
			},
        ];
    },
    ValidityList: async function () {
        return [
			// {
			// 	id: 1,
			// 	name: '1',
			// },
			// {
			// 	id: 2,
			// 	name: '2',
			// },
			// {
			// 	id: 3,
			// 	name: '3',
			// },

			// {
			// 	id: 1,
			// 	name: '1 Month',
			// },
			// {
			// 	id: 3,
			// 	name: '3 Months',
			// },
			// {
			// 	id: 6,
			// 	name: '6 Months',
			// },
			// {
			// 	id: 12,
			// 	name: '1 Year',
			// },
			// {
			// 	id: 24,
			// 	name: '2 Years',
			// },
			// {
			// 	id: 36,
			// 	name: '3 Years',
			// },
			// {
			// 	id: 48,
			// 	name: '4 Years',
			// },
			// {
			// 	id: 60,
			// 	name: '5 Years',
			// },

			{
				id: 1,
				name: '1 Year',
			},
			{
				id: 2,
				name: '2 Years',
			},
			{
				id: 3,
				name: '3 Years',
			},
			{
				id: 4,
				name: '4 Years',
			},
			{
				id: 5,
				name: '5 Years',
			},
        ];
    },
    ValidityTypeList: async function () {
        return [
			{
				id: ValidityTypeEnum.MONTH,
				name: ValidityType?.[ValidityTypeEnum.MONTH]?.title ?? "--",
			},
			{
				id: ValidityTypeEnum.YEAR,
				name: ValidityType?.[ValidityTypeEnum.YEAR]?.title ?? "--",
			},
        ];
    },
    DataStorageList: async function () {
        return [
			{
				id: 10,
				name: '10',
				price: 1000,
			},
			{
				id: 20,
				name: '20',
				price: 2000,
			},
			{
				id: 30,
				name: '30',
				price: 3000,
			},
			{
				id: 50,
				name: '50',
				price: 5000,
			},
			{
				id: 75,
				name: '75',
				price: 7500,
			},
			{
				id: 100,
				name: '100',
				price: 10000,
			},
        ];
    },
    NoOfUsersList: async function () {
        return [
			{
				id: 5,
				name: '5',
				price: 500,
			},
			{
				id: 10,
				name: '10',
				price: 1000,
			},
			{
				id: 20,
				name: '20',
				price: 2000,
			},
			{
				id: 30,
				name: '30',
				price: 3000,
			},
			{
				id: 50,
				name: '50',
				price: 5000,
			},
			{
				id: 51,
				name: '51 and above',
				price: 10000,
			},
        ];
    },
    CheckoutStepList: async function () {
        return [
			{
	            id: 1,
	            name: 'Billing Info',
	            btnName: "Billing Info",
	            icon: <IconUser />
	        },
	        {
	            id: 2,
	            name: 'Payment Info',
	            btnName: "Proceed to Payment",
	            icon: <IconCreditCard />
	        },
	        {
	            id: 3,
	            name: 'Finish',
	            btnName: "Pay Now",
	            icon: <IconCircleCheck />
	        },
        ];
    },
    PaymentTypeList: async function () {
        return [
			{
	            id: PaymentType.FPX,
	            name: 'FPX',
	            icon: <IconWorld />
	        },
	        {
	            id: PaymentType.CREDIT_DEBIT_CARD,
	            name: 'Credit / Debit Card',
	            icon: <IconCreditCard />
	        },
	        {
	            id: PaymentType.E_WALLET,
	            name: 'e-Wallet',
	            icon: <IconWallet />
	        },
        ];
    },
    BankList: async function () {
    	return [
			{
			    id: 'Affin Bank',
			    logo: 'assets/images/logo-affin.png',
			    name: 'Affin Bank',
			},
			{
			    id: 'Alliance Bank',
			    logo: 'assets/images/logo-alliance.png',
			    name: 'Alliance Bank',
			},
			{
			    id: 'AmBank',
			    logo: 'assets/images/logo-ambank.png',
			    name: 'AmBank',
			},
			{
			    id: 'Bank Islam',
			    logo: 'assets/images/logo-bank-islam.png',
			    name: 'Bank Islam',
			},
			{
			    id: 'Bank Rakyat',
			    logo: 'assets/images/logo-bank-rakyat.png',
			    name: 'Bank Rakyat',
			},
			{
			    id: 'Bank Muamalat',
			    logo: 'assets/images/logo-bank-muamalat.webp',
			    name: 'Bank Muamalat',
			},
			{
			    id: 'Bank of China',
			    logo: 'assets/images/logo-bank-of-china.png',
			    name: 'Bank of China',
			},
			{
			    id: 'Agrobank',
			    logo: 'assets/images/logo-agrobank.png',
			    name: 'Bank Pertanian Malaysia Berhad (Agrobank)',
			},
			{
			    id: 'BSN',
			    logo: 'assets/images/logo-bsn.png',
			    name: 'Bank Simpanan Nasional (BSN)',
			},
			{
			    id: 'CIMB',
			    logo: 'assets/images/logo-cimb.png',
			    name: 'CIMB Bank',
			},
			{
			    id: 'HLB',
			    logo: 'assets/images/logo-hlb.png',
			    name: 'Hong Leong Bank',
			},
			{
			    id: 'HSBC',
			    logo: 'assets/images/logo-hsbc.png',
			    name: 'HSBC Bank',
			},
			{
			    id: 'MBB',
			    logo: 'assets/images/logo-maybank.png',
			    name: 'Maybank',
			},
			{
			    id: 'OCBC',
			    logo: 'assets/images/logo-ocbc.png',
			    name: 'OCBC Bank',
			},
			{
			    id: 'PBB',
			    logo: 'assets/images/logo-pbb.png',
			    name: 'Public Bank',
			},
			{
			    id: 'RHB',
			    logo: 'assets/images/logo-rhb.png',
			    name: 'RHB Bank',
			},
			{
			    id: 'SCB',
			    logo: 'assets/images/logo-standard-chartered.png',
			    name: 'Standard Chartered Bank',
			},
			{
			    id: 'UOB',
			    logo: 'assets/images/logo-uob.jpg',
			    name: 'UOB Bank',
			},
    	];
    },
    EWalletList: async function () {
    	return [
			{
			    id: 'ALI',
			    logo: 'assets/images/ewallet-alipay.png',
			    name: 'Alipay',
			},
			{
			    id: 'SHO',
			    logo: 'assets/images/ewallet-shopeepay.png',
			    name: 'Shopee Pay',
			},
			{
			    id: 'WEP',
			    logo: 'assets/images/ewallet-wechatpay.png',
			    name: 'WeChat Pay',
			},
			{
			    id: 'TNG',
			    logo: 'assets/images/ewallet-TouchnGo.png',
			    name: 'TnG Wallet',
			},
			{
			    id: 'MBQ',
			    logo: 'assets/images/ewallet-maybankqr.png',
			    name: 'Maybank QR',
			},
			{
			    id: 'PRE',
			    logo: 'assets/images/ewallet-presto.png',
			    name: 'Presto',
			},
			{
			    id: 'ZAP',
			    logo: 'assets/images/ewallet-zapp.jpg',
			    name: 'Zapp',
			},
			{
			    id: 'BOO',
			    logo: 'assets/images/ewallet-boost.png',
			    name: 'Boost Pay',
			},
			{
			    id: 'SRW',
			    logo: 'assets/images/ewallet-sarawakpay.png',
			    name: 'Sarawak Pay',
			},
			{
			    id: 'RZP',
			    logo: 'assets/images/ewallet-razerpay.jpg',
			    name: 'Razer Pay',
			},
			{
			    id: 'GRB',
			    logo: 'assets/images/ewallet-grabpay.png',
			    name: 'Grab Pay',
			},
    	];
    },
    AdminRolesList: async function () {
    	return [
    		{
    			id: 'SysAdmin',
    			name: 'System Admin',
    		},
		    {
		    	id: 'Vendor',
		    	name: 'Vendor Admin',
		    },
		    {
		    	id: 'UserAdmin',
		    	name: 'User Admin',
		    },
		    {
		    	id: 'BillingAdmin',
		    	name: 'Billing Admin',
		    },
		] //temp for now; will check with BE team
    },
    StatusList: async function () {
		return [
			{
				id: ActiveStatusEnum.ACTIVE,
				name: 'Active',
			},
			{
				id: ActiveStatusEnum.INACTIVE,
				name: 'Inactive',
			},
		];
	},
	AdminModules: async function () {
		return [
			{
				id: AdminModules.DASHBOARD,
				name: RouteHelper.getRouteDescription(RouteEnum.DASHBOARD),
				subItems: [
					{
						id: AdminModules.DASHBOARD_CREATE_POST,
						name: 'Create Post',
					},
					{
						id: AdminModules.DASHBOARD_VIEW,
						name: 'View',
					},
				],
			},
			{
				id: AdminModules.NEWS,
				name: 'News',
				subItems: [
					{
						id: AdminModules.NEWS_CREATE,
						name: 'Create',
					},
					{
						id: AdminModules.NEWS_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.NEWS_EDIT,
						name: 'Edit',
					},
					{
						id: AdminModules.NEWS_DELETE,
						name: 'Delete',
					},
				],
			},
			{
				id: AdminModules.ADMIN_USER_CONTROL,
				name: RouteHelper.getRouteDescription(RouteEnum.ADMIN_USER_CONTROL),
				subItems: [
					{
						id: AdminModules.ADMIN_USER_CREATE,
						name: 'Create',
					},
					{
						id: AdminModules.ADMIN_USER_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.ADMIN_USER_EDIT,
						name: 'Edit',
					},
					{
						id: AdminModules.ADMIN_USER_DELETE,
						name: 'Delete',
					},
				],
			},
			{
				id: AdminModules.COMPANY,
				name: RouteHelper.getRouteDescription(RouteEnum.COMPANIES),
				subItems: [
					{
						id: AdminModules.COMPANY_CREATE,
						name: 'Create',
					},
					{
						id: AdminModules.COMPANY_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.COMPANY_EDIT,
						name: 'Edit',
					},
					{
						id: AdminModules.COMPANY_DELETE,
						name: 'Delete',
					},
				],
			},
			{
				id: AdminModules.BILLING,
				name: RouteHelper.getRouteDescription(RouteEnum.BILLINGS),
				subItems: [
					{
						id: AdminModules.BILLING_CREATE,
						name: 'Create',
					},
					{
						id: AdminModules.BILLING_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.BILLING_EDIT,
						name: 'Edit',
					},
					{
						id: AdminModules.BILLING_DELETE,
						name: 'Delete',
					},
				],
			},
			{
				id: AdminModules.LICENSE,
				name: RouteHelper.getRouteDescription(RouteEnum.LICENSES),
				subItems: [
					{
						id: AdminModules.GENERATE_LICENSE,
						name: 'Generate License',
					},
					{
						id: AdminModules.LICENSE_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.LICENSE_DELETE,
						name: 'Delete',
					},
					{
						id: AdminModules.BUY_LICENSE,
						name: 'Buy License',
					},
				],
			},
			{
				id: AdminModules.ACCESSIBILITIES,
				name: RouteHelper.getRouteDescription(RouteEnum.ACCESSIBILITIES),
				subItems: [
					{
						id: AdminModules.ACCESSIBILITIES_CREATE,
						name: 'Create',
					},
					{
						id: AdminModules.ACCESSIBILITIES_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.ACCESSIBILITIES_EDIT,
						name: 'Edit',
					},
					{
						id: AdminModules.ACCESSIBILITIES_DELETE,
						name: 'Delete',
					},
				],
			},
			{
				id: AdminModules.MODULE_SETTINGS,
				name: RouteHelper.getRouteDescription(RouteEnum.MODULE_SETTING),
				subItems: [
					{
						id: AdminModules.MODULE_SETTINGS_CREATE,
						name: 'Create',
					},
					{
						id: AdminModules.MODULE_SETTINGS_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.MODULE_SETTINGS_EDIT,
						name: 'Edit',
					},
					{
						id: AdminModules.MODULE_SETTINGS_DELETE,
						name: 'Delete',
					},
				],
			},
			{
				id: AdminModules.PRICE_SETTINGS,
				name: RouteHelper.getRouteDescription(RouteEnum.PRICE_SETTING),
				subItems: [
					{
						id: AdminModules.PRICE_SETTINGS_CREATE,
						name: 'Create',
					},
					{
						id: AdminModules.PRICE_SETTINGS_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.PRICE_SETTINGS_EDIT,
						name: 'Edit',
					},
					{
						id: AdminModules.PRICE_SETTINGS_DELETE,
						name: 'Delete',
					},
				],
			},
			{
				id: AdminModules.VENDORS,
				name: RouteHelper.getRouteDescription(RouteEnum.VENDORS),
				subItems: [
					{
						id: AdminModules.VENDORS_CREATE,
						name: 'Create',
					},
					{
						id: AdminModules.VENDORS_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.VENDORS_EDIT,
						name: 'Edit',
					},
					{
						id: AdminModules.VENDORS_DELETE,
						name: 'Delete',
					},
				],
			},
			// {
			// 	id: AdminModules.REGISTRATION_CODES,
			// 	name: RouteHelper.getRouteDescription(RouteEnum.REGISTRATION_CODES),
			// 	subItems: [
			// 		{
			// 			id: AdminModules.REGISTRATION_CODES_CREATE,
			// 			name: 'Create',
			// 		},
			// 		{
			// 			id: AdminModules.REGISTRATION_CODES_VIEW,
			// 			name: 'View',
			// 		},
			// 		{
			// 			id: AdminModules.REGISTRATION_CODES_EDIT,
			// 			name: 'Edit',
			// 		},
			// 		{
			// 			id: AdminModules.REGISTRATION_CODES_DELETE,
			// 			name: 'Delete',
			// 		},
			// 	],
			// },
			{
				id: AdminModules.MY_PROFILE,
				name: 'My Profille',
				subItems: [
					{
						id: AdminModules.MY_PROFILE_VIEW,
						name: 'View',
					},
					{
						id: AdminModules.MY_PROFILE_EDIT,
						name: 'Edit',
					},
				],
			},
		];
	},
	AccountTypeList: async function () {
		return [
			{
				id: AccountType.VENDOR,
				name: AccountTypeName[AccountType.VENDOR],
			},
			{
				id: AccountType.CUSTOMER,
				name: AccountTypeName[AccountType.CUSTOMER],
			},
		];
	},
	RegistrationTypeList: async function () {
		return [
			{
				id: RegistrationType.CUSTOMER,
				name: RegistrationTypeName[RegistrationType.CUSTOMER],
			},
			{
				id: RegistrationType.VENDOR,
				name: RegistrationTypeName[RegistrationType.VENDOR],
			},
		];
	},
	PriceSettingsTabList: async function () {
		return [
			{
				id: CurrencyEnum.MYR,
				name: 'Malaysia',
				currencyCode: CurrencyEnum.MYR,
				priceSettings: null,
			},
			{
				id: CurrencyEnum.PHP,
				name: 'Philippines',
				currencyCode: CurrencyEnum.PHP,
				priceSettings: null,
			},
		];
	},
	RoleTypeList: async function () {
		return [
			{
				id: RoleTypeEnum.DEFAULT,
				name: 'Default',
			},
			{
				id: RoleTypeEnum.USER_ADMIN,
				name: 'User Admin',
			},
			{
				id: RoleTypeEnum.VENDOR_ADMIN,
				name: 'Vendor Admin',
			},
			{
				id: RoleTypeEnum.SUPER_USER,
				name: 'Super User',
			},
		];
	},
};

const DropdownOptionsHelper: any = {
	getLists: async function (listName: any) {
		let _DropDownLists: any = {};

		// if (DropDownLists) {
		// 	for (const key in DropDownLists) {
		// 		_DropDownLists[key] = [...await DropdownOptionLists[key]()];
		// 	}
		// }

		if (listName != null && listName != "") {
            return await DropdownOptionLists[listName]();
        }

		return _DropDownLists;
	},
};


// const DropDownListsUtils = {
//     GetList: async function (listName) {
//         if (listName != null && listName != "") {
//             return await GetDropDownListData[listName]();
//         }
//     },
// }

export default DropdownOptionsHelper;